import { render, staticRenderFns } from "./ServicePost.vue?vue&type=template&id=67d86608&scoped=true"
import script from "./ServicePost.vue?vue&type=script&lang=js"
export * from "./ServicePost.vue?vue&type=script&lang=js"
import style0 from "./ServicePost.vue?vue&type=style&index=0&id=67d86608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d86608",
  null
  
)

export default component.exports